import { MediaMatcher } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterEvent,
} from "@angular/router";
import { MultilevelMenuService } from "@siu/shared";
import { Subscription } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";
import { AppStore } from "./core/store/app.store";
// import { AuthService } from "./core/services/auth.service";
import { TipoPerfilSIGO } from "./core/store/app.store.model";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  menuUpdate: any = [];
  showTransportista: boolean = false;
  showPersonaNatural: boolean = false;
  showCertificadora: boolean = false;
  showOperaciones: boolean = false;
  loadingRoute: boolean = false;

  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;

  readonly state$ = this.store.state$.pipe(
    map((state) => state),
    distinctUntilChanged()
  );

  private subscriptions: Subscription[] = [];

  constructor(
    private store: AppStore,
    public router: Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private multilevelMenuService: MultilevelMenuService,
    // private matIconRegistry: MatIconRegistry,
    // private domSanitzer: DomSanitizer
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => {
      changeDetectorRef.detectChanges();
      this.store.setIsMobile(this.mobileQuery.matches);
      if (this.mobileQuery.matches) {
        this.multilevelMenuService.expandFalse();
      } else {
        this.multilevelMenuService.expandTrue();
      }
    };
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.multilevelMenuService.expandFalse();

    this.multilevelMenuService.exand_menu.subscribe((exandvalue) => {
      if (exandvalue) {
        this.store.openDrawer();
      }
    });
    // this.matIconRegistry.addSvgIcon(
    //   'sigo_renovar',
    //   this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/renew.svg')
    // );
  }

  ngOnInit(): void {


    this.store.setIsMobile(this.mobileQuery.matches);

    
    let userSession = this.store.sessionAction.getUserSesion();

    if (userSession && userSession.TPerfil) {
      if (userSession.TPerfil.includes(TipoPerfilSIGO.EspecialistaOperaciones)) {
        this.store.state.ui.appMenu = [];
      }
    }
    
    this.store.setShowRightSidenav(true);
    this.subscribeToSession();
    this.subscribeToRouter();

    //  this.store.sessionAction.loginBegin();
    this.multilevelMenuService.expandFalse();

    if (this.store.sessionAction.esSesionValida()) {
      this.store.sessionAction.restablecerSesionDeLocalStorage();
    }
  }

  ngOnDestroy() {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.unSubscribe();
  }

  handleToogleDrawer = (open) => {
    if (open) {
      this.multilevelMenuService.expandTrue(); // menu expandido
      if (this.mobileQuery.matches) {
        this.store.openDrawerMobile();
      } else {
        this.store.openDrawer();
      }
    } else {
      this.multilevelMenuService.expandFalse();
      if (this.mobileQuery.matches) {
        this.store.closeDrawerMobile();
      } else {
        this.store.closeDrawer();
      }
    }
  };

  subscribeToSession = () => {
    const sub = this.store.state$
      .pipe(
        map((x) => x.session),
        distinctUntilChanged()
      )
      .subscribe((session) => {
        if (!session.isLoggedIn) {
        }
      });
    this.subscriptions.push(sub);
  };

  unSubscribe = () => {
    this.subscriptions.forEach((x) => {
      x.unsubscribe();
    });
  };

  subscribeToRouter = () => {
    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  };

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loadingRoute = true;
    }
    if (event instanceof NavigationEnd) {
      this.loadingRoute = false;
    }
    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loadingRoute = false;
    }
    if (event instanceof NavigationError) {
      this.loadingRoute = false;
    }
  }

  handleLogout = () => {
    this.store.sessionAction.logout();
    this.store.sessionAction.loginBegin();
    this.router.navigate(['/home'])
    //  this.authService.limpiarSesion();
  };
}
